import { Component, inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LockerSpirit } from '../../../../../core/models/lockerSpirit.model';
import { ApiService } from '../../../../../core/services/api.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ReversePipe } from '../../../../../core/pipes/reverse';
import { DatePipe } from '@angular/common';

const materialModules = [
  MatIconModule,
  MatDialogModule,
  MatButtonModule
]

const pipes = [
  ReversePipe,
  DatePipe
]

@Component({
  selector: 'app-spirit-detail-locker-consumption-history',
  standalone: true,
  imports: [TranslateModule, ...materialModules, ...pipes],
  templateUrl: './spirit-detail-locker-consumption-history.component.html',
  styleUrls: ['./spirit-detail-locker-consumption-history.component.scss']
})
export class SpiritDetailLockerConsumptionHistoryComponent implements OnInit {

  api = inject(ApiService);

  lockerSpirit: LockerSpirit | null = null;
  lockerUser: any = null;

  consumptions: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<SpiritDetailLockerConsumptionHistoryComponent>
  ) { }

  ngOnInit(): void {
    this.consumptions = this.lockerSpirit!.consumptions;
  }

  finishConsumption(consumption: any) {
    this.api.markConsumptionAsFinished(this.lockerUser.code, consumption.id).subscribe(
      data => {
        if (data.success) {
          consumption.status = 'finished';

          const index = this.consumptions.findIndex(x => x.id == consumption.id);
          this.consumptions[index] = consumption;
        }
      }
    );
  }

}
